import { createSlice } from "@reduxjs/toolkit";
import { dictService } from "../../services/dictService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";

export const getParents = createCustomAsyncThunk(
    "dicts/parents/get",
    async params => await dictService.getParents(params)
)

const parentsSlice = createSlice({
    name: "dicts/parents",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: false,
        error: null
    }),
    extraReducers: builder => {
        builder
            .addCase(getParents.pending, state => { state.isLoading = true })
            .addCase(getParents.fulfilled, (state, action) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getParents.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error
            })
    }
})

export const parentSelectors = defaultEntityAdapter.getSelectors(x => x.dicts.parents)

export default parentsSlice.reducer